// extracted by mini-css-extract-plugin
export default {"hotline_banner":"hotline_hotline_banner__XqeNP","hotline_left":"hotline_hotline_left__kh+xu","hotline_right":"hotline_hotline_right__qUt3a"};